/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Accordion, Card } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import {
  faCheckCircle,
  faCheckSquare,
  faTimes,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import api from '../../../services/API';
import { Link } from 'react-router-dom';
import { getClusterImageUrl } from '../../../utils/clusterImage';

import './styles.css';

export default function Cluster() {
  const parceiro = useSelector((state) => state.parceiro);

  const [niveis, setNiveis] = useState([]);
  const [buscando, setBuscando] = useState(false);

  useEffect(() => {
    buscarNiveis();
  }, []);

  const buscarNiveis = async () => {
    setBuscando(true);
    try {
      const response = await api.get('/api/cluster');
      setNiveis(response.data);
    } catch (error) {
      console.error('Erro ao buscar niveis:', error);
    } finally {
      setBuscando(false);
    }
  };

  const requisitos = [
    { key: 'clubProPintor', label: 'Clube Pro Pintor' },
    { key: 'enviandoNf', label: 'Enviando notas fiscais', link: '/enviar-nf' },
    { key: 'resgateItens', label: 'Resgate de itens (nos últimos 270 dias)', link: '/loja' },
    {
      key: 'cursosOne',
      label: 'Módulo de Cursos (ao menos 1)',
      link: '/cursos',
    },
    { key: 'cursosAll', label: 'Módulo de Cursos (todos)', link: '/cursos' },
    {
      key: 'acheSeuPintor',
      label: 'Ache Seu Pintor',
      link: '/ache-seu-pintor',
    },
    { key: 'fotoPerfil', label: 'Foto de Perfil', link: '/perfil' },
    {
      key: 'fotoVideoTrabalhos',
      label: 'Fotos e Vídeos dos trabalhos',
      link: '/ache-seu-pintor',
    },
    {
      key: 'parcelaPintura',
      label: 'Cadastro Parcela Pintura',
      link: 'https://parcelapintura.com.br/',
      external: true,
    },
  ];

  const requisitosFaltantes = requisitos.filter((req) => {
    const atualExige = parceiro?.cluster?.[req.key];
    const proximoExige = parceiro?.nextCluster?.[req.key];
    const parceiroCumpre = parceiro?.requisitos?.[req.key];

    // Só considera requisito novo ou mais exigente no próximo nível
    const passouAExigir = !atualExige && proximoExige;

    return passouAExigir && !parceiroCumpre;
  });

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Container className="mt-2 mb-5">
      <div className="mt-5">
        <h5>NÍVEIS</h5>
        <hr className="hr-loja mt-0" />
      </div>

      {buscando ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: '50vh' }}
        >
          <div className="spinner-border text-secondary" role="status">
            <span className="sr-only">Carregando...</span>
          </div>
        </div>
      ) : (
        <>
          {!isMobile && (
            <>
              {' '}
              <Row>
                <Col xs={7} className="d-flex flex-column mb-3">
                  <Row>
                    <Col xs={5}>
                      <div className="text-center mb-2" style={{ height: 80 }}>
                        <strong>Requisitos</strong>
                      </div>
                      {requisitos?.map((req) => (
                        <Row key={`req-label-${req.key}`}>
                          <Col style={{ height: 30 }} xs={12}>
                            {req.label}
                          </Col>
                        </Row>
                      ))}
                    </Col>

                    {niveis
                      ?.sort((a, b) => Number(a?.ordem) - Number(b?.ordem))
                      ?.map((nivel) => (
                        <Col
                          key={`nivel-${nivel?.id}`}
                          className="d-flex flex-column justify-content-center align-items-center mb-3"
                        >
                          <div
                            className="text-center mb-2"
                            style={{ height: 80 }}
                          >
                            {nivel?.img ? (
                              <img
                                src={getClusterImageUrl(nivel?.img)}
                                alt={nivel?.nome}
                                style={{ maxHeight: 50 }}
                              />
                            ) : (
                              '[ IMG ]'
                            )}
                            <div>{nivel?.nome}</div>
                          </div>
                          {requisitos?.map((req) => (
                            <Row key={`nivel-${nivel?.id}-${req?.key}`}>
                              <Col xs={12} style={{ height: 30 }}>
                                <FontAwesomeIcon
                                  color={nivel[req?.key] ? '#123474' : 'red'}
                                  icon={
                                    nivel[req?.key] ? faCheckSquare : faTimes
                                  }
                                />
                              </Col>
                            </Row>
                          ))}
                        </Col>
                      ))}
                  </Row>
                </Col>

                <Col xs={5} className="d-flex flex-column pt-4">
                  {!parceiro?.cluster?.nome && (
                    <>
                      <p className="mt-5">
                        Para aproveitar os benefícios de ser um pintor Bronze,
                        você apenas precisa enviar uma Nota e aguardar que ela
                        seja validada.
                      </p>

                      <Link to={'/enviar-nf'}>
                        <FontAwesomeIcon
                          icon={faTimes}
                          color="red"
                          className="mr-2"
                        />{' '}
                        Enviar Nota
                      </Link>
                    </>
                  )}
                  {parceiro?.cluster?.nome && (
                    <p className="mt-5">
                      Você está no nível{' '}
                      <strong>
                        {parceiro?.cluster?.nome || 'Desconhecido'}
                      </strong>
                    </p>
                  )}

                  {parceiro?.nextCluster?.nome && (
                    <>
                      <p>
                        Para subir ao nível{' '}
                        <strong>{parceiro?.nextCluster?.nome}</strong> você
                        precisa:
                      </p>
                      {requisitosFaltantes?.length > 0 ? (
                        <>
                          {requisitosFaltantes?.map((req) => (
                            req.external ? (
                              <a
                                href={req.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                key={req.key}
                              >
                                <FontAwesomeIcon
                                  icon={faTimes}
                                  color="red"
                                  className="mr-2"
                                />{' '}
                                {req?.label}
                              </a>
                            ) : (
                              <Link to={req.link} key={req.key}>
                                <FontAwesomeIcon
                                  icon={faTimes}
                                  color="red"
                                  className="mr-2"
                                />{' '}
                                {req?.label}
                              </Link>
                            )
                          ))}
                        </>
                      ) : (
                        <p>Parabéns! Você já atende todos os requisitos. 🎉</p>
                      )}
                    </>
                  )}
                </Col>
              </Row>
            </>
          )}

          {isMobile && (
            <>
              {parceiro?.cluster?.nome && (
                <p className="mt-5">
                  Você está no nível{' '}
                  <strong>{parceiro?.cluster?.nome || 'Desconhecido'}</strong>
                </p>
              )}
              {parceiro?.nextCluster?.nome && (
                <>
                  <p>
                    Para subir ao nível{' '}
                    <strong>{parceiro?.nextCluster?.nome}</strong> você precisa:
                  </p>
                      {requisitosFaltantes?.length > 0 ? (
                        <>
                          {requisitosFaltantes?.map((req) => (
                            <p key={req.key}>
                              {req.external ? (
                                <a
                                  href={req.link}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <FontAwesomeIcon
                                    icon={faTimes}
                                    color="red"
                                    className="mr-2"
                                  />{' '}
                                  {req.label}
                                </a>
                              ) : (
                                <Link to={req.link}>
                                  <FontAwesomeIcon
                                    icon={faTimes}
                                    color="red"
                                    className="mr-2"
                                  />{' '}
                                  {req.label}
                                </Link>
                              )}
                            </p>
                          ))}
                        </>
                      ) : (
                    <p>Parabéns! Você já atende todos os requisitos. 🎉</p>
                  )}
                </>
              )}
              <Accordion>
                {niveis
                  ?.sort((a, b) => Number(a.ordem) - Number(b.ordem))
                  ?.map((nivel, idx) => (
                    <Card key={String(idx)}>
                      <Accordion.Toggle as={Card.Header} eventKey={String(idx)}>
                        <div className="d-flex align-items-center gap-2">
                          {nivel?.img && (
                            <img
                              src={getClusterImageUrl(nivel?.img)}
                              alt={nivel?.nome}
                              style={{ height: 24, marginRight: 8 }}
                            />
                          )}
                          {nivel?.nome}
                        </div>
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey={String(idx)}>
                        <Card.Body>
                          {requisitos.map((req) =>
                            req.external ? (
                              <a
                                href={req.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                key={req?.key}
                              >
                                <div className="d-flex align-items-center my-1  gap-2">
                                  <FontAwesomeIcon
                                    icon={
                                      nivel[req?.key]
                                        ? faCheckCircle
                                        : faTimesCircle
                                    }
                                    color={nivel[req?.key] ? '#123474' : 'red'}
                                    className="me-2 mr-2"
                                  />
                                  {req?.label}
                                </div>
                              </a>
                            ) : (
                              <Link to={req?.link} key={req?.key}>
                                <div className="d-flex align-items-center my-1  gap-2">
                                  <FontAwesomeIcon
                                    icon={
                                      nivel[req?.key]
                                        ? faCheckCircle
                                        : faTimesCircle
                                    }
                                    color={nivel[req?.key] ? '#123474' : 'red'}
                                    className="me-2 mr-2"
                                  />
                                  {req?.label}
                                </div>
                              </Link>
                            )
                          )}
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                  ))}
              </Accordion>
            </>
          )}
        </>
      )}
    </Container>
  );
}
